import { noop } from "lodash";
import React from "react";
import EventTableLoading from "./EventTableLoading";
import { EventTableMessage } from "./EventTableMessage";

type Props = {
  caption?: string;
  emptyText?: string;
  errorText?: string;
  loading?: boolean;
  onFlexibilityChange?: (eventId: string, isFlexible: boolean) => void;
  showAvatars?: boolean;
  updating?: boolean;
};

const EventTable = ({
  caption,
  children,
  emptyText = "You have no other flexible events yet.",
  errorText = "",
  loading = false,
  onFlexibilityChange = noop,
  showAvatars = false,
  updating = false,
}: React.PropsWithChildren<Props>) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child as JSX.Element, {
        showAvatars,
        onFlexibilityChange,
        updating,
      });
    }
    return child;
  });

  if (errorText) {
    return <EventTableMessage message={errorText} isError />;
  }

  if (!childrenWithProps?.length && !loading) {
    return <EventTableMessage message={emptyText} />;
  }

  return (
    <div className="cw-body-base">
      <table className="cw-table-auto cw-border-collapse cw-w-full cw-border-0 cw-border-b cw-border-solid cw-border-muted">
        {caption && <caption className="cw-hidden">{caption}</caption>}
        <tbody>
          {loading ? <EventTableLoading showAvatars={showAvatars} /> : childrenWithProps}
        </tbody>
      </table>
    </div>
  );
};

export default EventTable;
